/*
包含n个接口请求函数的模块
函数的返回值: promise对象
 */
import ajax from './ajax'
const BASE_URL = '/api/v1' // search

// 1. 获取首页标题聚类数据

// 2.检索接口
export const reqSearchResult = ({query, fq, pageNo, pageSize, core, highLight, facets, facetPivot, returnFeild, sort, searchType}) => ajax(BASE_URL + '/search', {query, fq, pageNo, pageSize, core, highLight, facets, facetPivot, returnFeild, sort, searchType}, 'POST')
export const reqDefaultIndex = (opt) => ajax(BASE_URL + '/search', {
  fq: ['Province:' + opt.province || '', 'City:' + opt.city || ''],
  core: opt.core || 'LocalChronicleOpera'
}, 'POST')

// 3.获取导航分类数据(地区)
export const reqCategorys = () => ajax(BASE_URL + '/search', {
  facetPivot: ['Province', 'City'],
  core: 'LocalChronicleOpera'
}, 'POST')

// 4.获取导航分类数据(主题)
export const reqTopicCategorys = (opt) => ajax(BASE_URL + '/search', {
  facetPivot: ['Province', 'City'],
  core: 'LocalChronicleOpera'
}, 'POST')
// this.$http.post('/api/v1/search', {
//   query: opt.query || '',
//   core: opt.core || "LocalChronicleOpera",
//   pageSize: 15,
//   fq: ['Province:'+ opt.province || '',"City:"+ opt.city || '']
// 5.search
export const reqSearch = (opt) => ajax(BASE_URL + '/search', {
  query: opt.query || '',
  fq: opt.fq || [],
  pageNo: opt.pageNo || 1,
  pageSize: 20,
  core: opt.core || 'LocalChronicleItemOpera',
  highLight: opt.highLight || [], // 检索高亮  xxx_HL
  facets: opt.facets || [], // 多个聚类 ['xx','xx']
  facetPivot: opt.facetPivot || [], // 多级聚类
  returnFeild: opt.returnFeild || [],
  sorts: opt.sorts || [{feild: 'Date', order: 'desc'}],
  searchType: opt.searchType || ''
}, 'POST')
// 条目目录
export const reqItemList = (opt) => ajax(BASE_URL + '/search', {
  fq: opt.fq || [],
  core: 'LocalChronicleItemOpera',
  searchType: 'content'
}, 'POST')
// 书内检索
export const reqInnerItemList = (opt) => ajax(BASE_URL + '/search', {
  fq: opt.fq || [],
  core: opt.core || '',
  query: opt.query || '',
  pageSize: opt.pageSize || 6,
  pageNo: opt.pageNo || 1,
  searchType: 'contentSearch'
}, 'POST')

export const reqSearchCategory = (opt) => ajax(BASE_URL + '/search', {
  query: opt.query || '',
  fq: opt.fq || [],
  pageNo: opt.pageNo || 1,
  pageSize: 15,
  core: opt.core || 'LocalChronicleOpera',
  highLight: opt.highLight || [], // 检索高亮  xxx_HL
  facets: opt.facets || [], // 多个聚类 ['xx','xx']
  facetPivot: opt.facetPivot || [], // 多级聚类
  returnFeild: opt.returnFeild || [],
  sorts: opt.sorts || [{feild: 'BookTitle', order: 'desc'}]
}, 'POST')

// 3.获取首页专题分类数据(地区)
export const reqIndexCategorys = () => ajax(BASE_URL + '/search', {
  facetPivot: ['CategoryA', 'CategoryB'],
  core: 'LocalChronicleItemOpera'
}, 'POST')

// 4.获取用户信息
export const reqUserInfo = () => ajax(BASE_URL + '/users?' + new Date().getMilliseconds())

// 5.获取条目详情
export const reqItemDetail = (bookId) => ajax(BASE_URL + '/search', {
  fq: 'BookID:' + bookId,
  core: 'LocalChronicleItemOpera',
  searchType: 'content'
}, 'POST')



// WEBPACK FOOTER //
// ./src/api/index.js